import { render, staticRenderFns } from "./myComplaintsTab.vue?vue&type=template&id=37ee6530"
import script from "./myComplaintsTab.vue?vue&type=script&lang=js"
export * from "./myComplaintsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports